import { capitalizeFirst } from "../../utils/function";

export const ErrorMessageTypo = ({ error }) => {
  return (
    <div style={{ color: "red", fontSize: "0.8rem", fontStyle: "italic" }}>
      {capitalizeFirst(error)}
    </div>
  );
};

export default ErrorMessageTypo;
